import React from 'react';

import PropTypes from 'prop-types';

import {Box, Paper, Stack, Typography} from 'views/components';
import {CreditCardOutlined as CreditCardOutlinedIcon} from 'views/icons';

import {SecureImageDisplay} from 'views/module/secureStorage/DisplayComponents';
import {Translate} from 'views/module';

const ReimbursementTile = (props) => {
  const {reimbursement} = props;

  const expenses = reimbursement.expenseReimbursement.expenses;

  return (
    <Paper sx={{p: 2, mb: 2, borderRadius: 4}}>
      <Stack spacing={2} sx={{px: 2, py: 1}}>
        <Stack direction="row" alignItems="center" spacing={1}>
          <CreditCardOutlinedIcon sx={{width: 24, height: 24, color: '#b0b0b0'}} />
          <Typography variant="h6">
            <Translate expression='schedule.eventDetail.ReimbursementSection.Title' />
          </Typography>
        </Stack>
        {
          expenses.map((exp, idx) => (
            <Box
              key={idx}
              sx={{
                border: 1,
                borderColor: 'divider',
                borderRadius: 3,
                bgcolor: 'background.paper',
                overflow: 'hidden',
              }}
            >
              {/* Header: title and amount */}
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  px: 3,
                  pt: 2,
                  pb: 1,
                }}
              >
                <Typography variant="h6" sx={{fontWeight: 600}}>
                  {exp.title}
                </Typography>
                <Typography variant="h6" sx={{fontWeight: 700}}>
                  <Translate expression='client.ClientDetail.Payment.Expense.Amount' substitute={{expenses: exp.price}}/>
                </Typography>
              </Box>

              {/* Images row */}
              {
                exp.pictures && exp.pictures.length > 0 && (
                  <Box
                    sx={{
                      px: 3,
                      pb: 2,
                    }}
                  >
                    <SecureImageDisplay
                      images={exp.pictures.map((src) => ({src}))}
                      sx={{marginTop: 1}}
                    />
                  </Box>
                )
              }
            </Box>
          ))
        }
      </Stack>
    </Paper>
  );
};


ReimbursementTile.propTypes = {
  reimbursement: PropTypes.object.isRequired,
};

export default ReimbursementTile;
